import { trackApi } from '@ardoq/api';
import { isAutomatedTestMode, isDevelopmentMode, isOnPremise } from '../env';

export const track: TrackFn = (name, metadata) => {
  // eslint-disable-next-line no-console
  if (isDevelopmentMode()) console.info(`Tracking ${name}`, metadata);
  if (isOnPremise()) return;
  if (isAutomatedTestMode()) return;

  trackApi.trackEvent({
    name,
    metadata,
    context: {
      userAgent: navigator.userAgent,
      page: {
        path: window.location.pathname,
        referrer: document.referrer,
      },
    },
    client: 'ardoq-front',
  });
};

// currently restricted only for certain types of events and clients
// there is a rate limiter based on event name and IP address
export const trackUnauthenticated: TrackFn = (name, metadata) => {
  // eslint-disable-next-line no-console
  if (isDevelopmentMode()) console.info(`Tracking ${name}`, metadata);
  if (isOnPremise()) return;
  if (isAutomatedTestMode()) return;

  trackApi.trackEarlyEvent({
    name,
    metadata,
    context: {
      userAgent: navigator.userAgent,
      page: {
        path: window.location.pathname,
        referrer: document.referrer,
      },
    },
    client: 'ardoq-front',
  });
};

export type TrackFn = (
  name: string,
  metadata?: Record<string, unknown>
) => void;
